import { Button, Checkbox, FormControlLabel, IconButton } from '@mui/material'
import React, { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditStorageDialog from '../../../Modals/EditStorageDialog';
import ConfirmDialog from '../../../Modals/ConfirmDialog';
import { useDeleteStorageMutation, useUpdateStorageMutation } from '../../../../features/fullApi';

const Storage = (storage) => {

    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const user = JSON.parse(localStorage.getItem('user'))


    const openModalEditItem = ((storage) => {
        setOpenEdit(true)
      })

      const editItemMessage = "You are updating this item"
  
      const [updateStorage] = useUpdateStorageMutation()
      const [deleteStorage] = useDeleteStorageMutation()
    
      const message = "Are you sure you want to delete this storage ?";
    
      const openDeleteModal = (() => {
        setOpen(true)
      })
    
      const handleUpdateStorage = ((storage) => {
        setOpenEdit(false)
        updateStorage({_id: storage.id._id, amount: storage.amount, type: storage.type}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        }).then(res => {

        })
      })
    
      const handleDelete = (async (storageId) => {
        deleteStorage({id: storageId}).then(res => {

        })
        setOpen(false)
      })

  return (
    <>
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    {user?.isAdmin && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <Button aria-label="Edit Item" onClick={() => openModalEditItem(storage.storage._id)}>
              <EditIcon style={{color: 'orange'}}/>
            </Button>
            <Button aria-label="Delete product" onClick={() => openDeleteModal(storage.storage._id)} size="small">
            <DeleteIcon style={{color: 'red'}}/>
            </Button>
        </div>
    )}
    </div>
    <EditStorageDialog openEdit={openEdit} handleUpdateStorage={handleUpdateStorage} setOpenEdit={setOpenEdit} item={storage.storage} message={editItemMessage}>         
    </EditStorageDialog>
    <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={storage.storage} message={message}></ConfirmDialog>
  </>
  )
}

export default Storage